import { useMutation } from '@tanstack/react-query'
import { supabase } from '../lib/supabase'
import { useAppStore } from '../stores/app'

export interface UpdateProfileInput {
  full_name: string | null
  role: string | null
}

export function useUpdateProfile() {
  const setCurrentUser = useAppStore((state) => state.setCurrentUser)

  return useMutation({
    mutationFn: async ({
      userId,
      full_name,
      role,
    }: UpdateProfileInput & { userId: string }) => {
      const { data, error } = await supabase
        .from('user_profiles')
        .update({
          full_name,
          role,
          updated_at: new Date().toISOString(),
        })
        .eq('id', userId)
        .select()
        .single()

      if (error) throw error
      return data
    },
    onSuccess: (data) => {
      if (data) {
        setCurrentUser({
          id: data.id,
          organization_id: data.organization_id ?? null,
          full_name: data.full_name ?? null,
          role: data.role ?? null,
        })
      }
    },
  })
}
